import Reveal from '@/components/base/Reveal';
import Counter from '@/components/base/Counter';
import { referenceSectors, syntferPartner, trainingFigures } from '@/mocks/formation';

export default function References() {
  return (
    <section id="references" className="relative overflow-hidden bg-foreground-950 py-16 md:py-24">
      <div className="absolute inset-0 hatch-lines-light opacity-25" />
      <div className="container-wide relative z-10">
        <Reveal>
          <div className="grid gap-6 lg:grid-cols-[1.1fr_0.9fr] lg:items-end">
            <div>
              <div className="flex items-center gap-3">
                <span className="h-px w-8 bg-primary-500" />
                <span className="label-mono text-primary-300">Références &amp; partenaires</span>
              </div>
              <h2 className="display-title mt-5 text-4xl text-background-50 md:text-5xl">
                Nos ouvrages tournent
                <br />
                dans six industries
              </h2>
            </div>
            <p className="text-sm leading-relaxed text-background-300">
              Nos formations s’appuient sur des chantiers réels et sur un réseau d’entreprises
              industrielles de la place. Certains de nos stagiaires rejoignent directement leurs
              ateliers à l’issue du parcours.
            </p>
          </div>
        </Reveal>

        {/* Real partner */}
        <Reveal delay={80}>
          <a
            href={syntferPartner.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group mt-10 flex flex-col gap-5 rounded-lg border border-primary-500/40 bg-background-50/5 p-5 transition-colors duration-300 hover:border-primary-500 hover:bg-background-50/10 sm:flex-row sm:items-center sm:justify-between"
          >
            <div className="flex items-start gap-4 sm:items-center">
              <span className="flex h-14 w-14 flex-shrink-0 items-center justify-center bg-primary-500 font-heading text-xl font-semibold tracking-[0.08em] text-background-50">
                {syntferPartner.monogram}
              </span>
              <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="font-heading text-2xl font-semibold uppercase tracking-wide text-background-50">
                    {syntferPartner.name}
                  </span>
                  <span className="rounded-full bg-primary-500/20 px-2 py-0.5 font-label text-[9px] uppercase tracking-[0.14em] text-primary-300">
                    {syntferPartner.label}
                  </span>
                </div>
                <p className="mt-1 text-[11px] uppercase tracking-[0.12em] text-background-400">
                  {syntferPartner.sector}
                </p>
                <p className="mt-1 text-xs text-background-500">syntfer.com</p>
              </div>
            </div>
            <span className="flex items-center gap-2 whitespace-nowrap text-[11px] font-semibold uppercase tracking-[0.12em] text-primary-300">
              Visiter le site
              <i className="ri-arrow-right-up-line text-base transition-transform duration-300 group-hover:-translate-y-0.5" />
            </span>
          </a>
        </Reveal>

        {/* Sector references */}
        <div className="mt-3 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {referenceSectors.map((sector, index) => (
            <Reveal key={sector.title} delay={index * 60}>
              <div className="flex h-full items-start gap-4 rounded-lg border border-background-50/10 bg-background-50/5 p-5 transition-colors duration-300 hover:border-background-50/30">
                <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-md border border-background-50/20 text-background-100">
                  <i className={`${sector.icon} text-lg`} />
                </span>
                <div className="min-w-0">
                  <p className="font-heading text-lg font-semibold uppercase leading-tight tracking-wide text-background-50">
                    {sector.title}
                  </p>
                  <p className="mt-1 text-[11px] uppercase tracking-[0.12em] text-background-400">
                    {sector.zone}
                  </p>
                  <p className="mt-1.5 text-xs leading-relaxed text-background-300">
                    {sector.scope}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <p className="mt-4 max-w-3xl text-[10px] uppercase leading-relaxed tracking-[0.14em] text-background-500">
            Noms et logos publiés uniquement avec l’accord écrit des entreprises. Les références
            détaillées et les attestations de bonne exécution sont communiquées sur demande lors
            d’une consultation.
          </p>
        </Reveal>

        {/* Training figures */}
        <Reveal delay={100}>
          <div className="mt-10 flex items-center gap-3">
            <span className="h-px w-8 bg-primary-500" />
            <span className="label-mono text-primary-300">Le centre en chiffres</span>
          </div>
        </Reveal>

        <div className="mt-5 grid grid-cols-2 gap-px overflow-hidden rounded-lg bg-background-50/20 md:grid-cols-4">
          {trainingFigures.map((figure) => (
            <div key={figure.label} className="bg-foreground-950 px-5 py-6">
              <p className="font-heading text-4xl font-semibold leading-none text-primary-400">
                <Counter value={figure.value} suffix={figure.suffix} />
              </p>
              <p className="mt-2 text-[10px] uppercase leading-snug tracking-[0.14em] text-background-200">
                {figure.label}
              </p>
              <p className="mt-1 text-[11px] leading-snug text-background-400">{figure.hint}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}